// src/index.ts
import { after } from "next/server.js";
var BetterErrors = class {
  url;
  options;
  user;
  constructor(url, options) {
    this.url = url;
    this.options = options || { isEnabled: true };
  }
  setUser(user) {
    this.user = user;
  }
  sendError(data) {
    if (!this.options.isEnabled) return;
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...data, user: this.user })
    };
    try {
      if (typeof window === "undefined") {
        after(fetch(this.url, options));
      } else {
        void fetch(this.url, options).catch();
      }
    } catch (error) {
      console.error(error);
    }
  }
  getBrowserInfo() {
    if (typeof window === "undefined") return {};
    const userAgent = navigator.userAgent;
    const language = navigator.language;
    const location = window.location.href;
    const referrer = document.referrer;
    const screenSize = {
      width: window.screen.width,
      height: window.screen.height,
      availWidth: window.screen.availWidth,
      availHeight: window.screen.availHeight,
      colorDepth: window.screen.colorDepth,
      pixelDepth: window.screen.pixelDepth
    };
    const viewport = {
      width: window.innerWidth,
      height: window.innerHeight
    };
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const cookiesEnabled = navigator.cookieEnabled;
    return { userAgent, language, location, referrer, screenSize, viewport, timeZone, cookiesEnabled };
  }
  capture(error, context) {
    const errorMessage = error.message || String(error);
    const errorStack = error.stack;
    const errorCode = error.code || error.statusCode || error.status;
    let errorName = "";
    if (error) {
      if (error.name) {
        errorName = error.name;
      } else if (error.constructor?.name) {
        errorName = error.constructor.name;
      } else if (Object.prototype.toString.call(error) === "[object Error]") {
        errorName = "Error";
      } else {
        errorName = "Unknown";
      }
    }
    const browserInfo = this.getBrowserInfo();
    const pageUrl = typeof window !== "undefined" ? window.location.href : context?.request?.path;
    const errorType = typeof window !== "undefined" ? "client" : "server";
    const errorData = {
      errorName,
      errorType,
      errorMessage,
      errorStack,
      errorCode: errorCode ? String(errorCode) : void 0,
      pageUrl,
      userAgent: browserInfo.userAgent,
      metadata: {
        ...context?.extras,
        ...browserInfo,
        nextContext: context?.nextContext,
        request: context?.request
      }
    };
    this.sendError(errorData);
  }
  captureUnhandledRejection(reason) {
    this.capture(reason);
  }
  onRequestError(error, request, nextContext) {
    this.capture(error, { request, nextContext });
  }
  initClient() {
    if (typeof window === "undefined") return;
    window.addEventListener("error", (event) => {
      this.capture(event.error);
    });
    window.addEventListener("unhandledrejection", (event) => {
      this.captureUnhandledRejection(event.reason);
    });
  }
};
export {
  BetterErrors
};
